// The purple app header used at the top of the tabbed screens, with its row of
// stat pills — a port of `ui/Components.kt` (`SadieHeader` + `RowScopeStatPill`).

export interface Stat {
  value: string;
  label: string;
}

export default function Header({
  title,
  subtitle,
  stats,
}: {
  title: string;
  subtitle: string;
  stats: Stat[];
}) {
  return (
    <header className="header">
      <h1>{title}</h1>
      <p className="subtitle">{subtitle}</p>
      <div className="stats">
        {stats.map((stat) => (
          <div className="stat" key={stat.label}>
            <div className="value">{stat.value}</div>
            <div className="label">{stat.label}</div>
          </div>
        ))}
      </div>
    </header>
  );
}
